'use client'

import { motion } from 'motion/react'
import { useTranslations } from 'next-intl'

import { useNewsList } from '@/features/news/hooks'
import Loader from '@/shared/ui/Loader'

import NewsHeroFeatured from './components/NewsHeroFeatured'
import NewsList from './components/NewsList'
import NewsPageHero from './components/NewsPageHero'
import SalesBanner from './components/SalesBanner'
import { NEWS_GRID_PAGE_SIZE, NEWS_LIST_FETCH_SIZE } from './constants'
import S from './NewsPage.module.scss'
import { fadeInUp, revealViewport } from './utils/animations'

// OCE-600: page loader waits for the featured hero and news list grid.
export default function NewsPageClient() {
  const { isLoading: isNewsListLoading } = useNewsList({
    limit: NEWS_GRID_PAGE_SIZE,
    firstPageLimit: NEWS_LIST_FETCH_SIZE
  })
  const t = useTranslations('news')

  return isNewsListLoading ? (
    <Loader variant="fullscreen" />
  ) : (
    <div className={S.newsPage}>
      <NewsPageHero>
        <div className={S.container}>
          <motion.h1
            className={S.pageTitle}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={revealViewport}
          >
            {t('page.title')}
          </motion.h1>
          <NewsHeroFeatured />
        </div>
      </NewsPageHero>
      <SalesBanner />
      <div className={S.container}>
        <NewsList />
      </div>
    </div>
  )
}
